import React from 'react';
import { PROBLEM_REPORT_FALLBACK, problemReportHref } from '../lib/problemReportLink.js';

export default function ProblemReportLink({ style }) {
  const prepare = (event) => { event.currentTarget.href = problemReportHref(window.location); };
  return <a href={PROBLEM_REPORT_FALLBACK} target="_blank" rel="noopener noreferrer"
    onClick={prepare} onAuxClick={prepare} onContextMenu={prepare}
    aria-label="Probleem melden (opent in een nieuw tabblad)" title="Probleem melden (opent in een nieuw tabblad)"
    style={{ display: 'inline-block', fontSize: 13, fontWeight: 600, padding: '8px 0', textUnderlineOffset: 3, ...style }}>
    Probleem melden
  </a>;
}
